import Vue from 'vue';
import VueResource from 'vue-resource';
import converterObjetoFormData from '~js/converter-objeto-formdata';

Vue.use(VueResource);

export default {
  lista: (filtros) => {
    const filtro = converterObjetoFormData(filtros);

    return Vue.http.post('/api/liberarsolicitacao', filtro).then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-solicitacoes/servico.js